import pagesIcon from "../assets/pages.svg";
import navIcon from "../assets/nav.svg";
import contactIcon from "../assets/contact.svg";
import blogsIcon from "../assets/blogs.svg";
import fileIcon from "../assets/file-icon.svg";
import libraryIcon from "../assets/media.svg";
import settingIcon from "../assets/setting.svg";
import sectionIcon from "../assets/section.svg";
import organizationIcon from "../assets/organization.svg";
import projectsIcon from "../assets/projects.svg";

const sideMenuConfig = {
  tec: [
    { label: "Organization", path: "/organization", icon: organizationIcon },
    { label: "Projects", path: "/projects", icon: projectsIcon },
    { label: "Pages", path: "/pages", icon: pagesIcon },
    { label: "Navigation", path: "/navigation", icon: navIcon },
    { label: "Forms", path: "/all-forms", icon: contactIcon },
    { label: "Blogs", path: "/blogs", icon: blogsIcon },
    { label: "Case Studies", path: "/case-studies", icon: fileIcon },
    { label: "Media News", path: "/news-list", icon: fileIcon },
    { label: "Media Library", path: "/media-library", icon: libraryIcon },
    { label: "Section Masters", path: "/section", icon: sectionIcon },
    { label: "Settings", path: "/settings", icon: settingIcon },
  ],

  the: [
    { label: "Organization", path: "/organization", icon: organizationIcon },
    { label: "Projects", path: "/projects", icon: projectsIcon },
    { label: "Pages", path: "/pages", icon: pagesIcon },
    { label: "Navigation", path: "/navigation", icon: navIcon },
    { label: "Forms", path: "/all-forms", icon: contactIcon },
    { label: "Blogs", path: "/blogs", icon: blogsIcon },
    { label: "Media Library", path: "/media-library", icon: libraryIcon },
    { label: "Section Masters", path: "/section", icon: sectionIcon },
    { label: "Settings", path: "/settings", icon: settingIcon },
  ],

  eva: [
    { label: "Organization", path: "/organization", icon: organizationIcon },
    { label: "Projects", path: "/projects", icon: projectsIcon },
    { label: "Pages", path: "/pages", icon: pagesIcon },
    { label: "Navigation", path: "/navigation", icon: navIcon },
    { label: "Forms", path: "/all-forms", icon: contactIcon },
    { label: "Blogs", path: "/blogs", icon: blogsIcon },
    { label: "Media Library", path: "/media-library", icon: libraryIcon },
    { label: "Section Masters", path: "/section", icon: sectionIcon },
    { label: "Settings", path: "/settings", icon: settingIcon },
  ],

  default: [
    { label: "Organization", path: "/organization", icon: organizationIcon },
    { label: "Projects", path: "/projects", icon: projectsIcon },
    { label: "Pages", path: "/pages", icon: pagesIcon },
    { label: "Navigation", path: "/navigation", icon: navIcon },
    { label: "Forms", path: "/all-forms", icon: contactIcon },
    { label: "Blogs", path: "/blogs", icon: blogsIcon },
    { label: "Media Library", path: "/media-library", icon: libraryIcon },
    { label: "Section Masters", path: "/section", icon: sectionIcon },
    { label: "Settings", path: "/settings", icon: settingIcon },
  ],
};

export default sideMenuConfig;
